import {
  BILLING_DASHBOARD,
  FEE_HISTORY_SECTION,
  BILLING_SECTION,
  BILLING_PROFILE_SECTION,
  BURN_FEE_IMPROVEMENTS,
} from '@services/permissions'
import { STRIPE_ENABLED } from '@services/permissions/sets/account/stripeEnabled/stripeEnabled'

import type { Section } from '../types'

export const cardDetails: Section = {
  label: 'layout:page.billing.payment-methods.card',
  route: '/billing/payment-methods/[id]',
  permissions: BILLING_DASHBOARD,
  segment: {
    page: 'settings',
  },
}

export const editCardPaymentMethod: Section = {
  label: 'layout:page.billing.payment-methods.edit-card-payment-method.title',
  route: '/billing/payment-methods/edit-card-payment-method/[id]',
  permissions: STRIPE_ENABLED,
  segment: {
    page: 'settings',
  },
}

export const paymentMethodsSection: Section = {
  label: 'layout:page.billing.payment-methods.title',
  route: '/billing/payment-methods',
  permissions: BILLING_DASHBOARD,
  segment: {
    page: 'settings',
  },
}

export const invoiceDetailsSection: Section = {
  label: 'layout:page.billing.invoices.detail',
  route: '/billing/invoices/[id]',
  permissions: BILLING_DASHBOARD,
  segment: {
    page: 'settings',
  },
}

export const invoicesSection: Section = {
  label: 'layout:page.billing.invoices.title',
  route: '/billing/invoices',
  permissions: BILLING_DASHBOARD,
  segment: {
    page: 'settings',
  },
}

export const autoPaySection: Section = {
  label: 'layout:page.billing.autopay',
  route: '/billing/autopay',
  permissions: BILLING_DASHBOARD,
  segment: {
    page: 'settings',
  },
}

export const feeHistorySection: Section = {
  label: 'layout:page.billing.feeHistory',
  route: '/billing/feeHistory',
  permissions: FEE_HISTORY_SECTION,
  segment: {
    page: 'settings',
  },
}

export const feeDetailsSection: Section = {
  label: 'layout:page.billing.feeDetails',
  route: '/billing/feeHistory/[id]',
  permissions: BURN_FEE_IMPROVEMENTS,
  segment: {
    page: 'settings',
  },
}

export const billingProfileSection: Section = {
  label: 'layout:page.billing.profile',
  route: '/billing/profile',
  permissions: BILLING_PROFILE_SECTION,
  segment: {
    page: 'settings',
  },
}

export const billingSection: Section = {
  label: 'layout:page.billing.title',
  route: '/billing/invoices',
  permissions: BILLING_SECTION,
  icon: 'CurrencyDollarOutline',
  pages: [
    invoiceDetailsSection,
    invoicesSection,
    cardDetails,
    paymentMethodsSection,
    autoPaySection,
    feeHistorySection,
    feeDetailsSection,
    editCardPaymentMethod,
    billingProfileSection,
  ],
  segment: {
    page: 'settings',
  },
}
